import { startCase } from 'lodash'
import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { StarIcon } from 'assets/icons/star-icon'

import { playerOrbs } from 'features/board/utils'
import { useSoundContext } from 'features/sound/sound-context'

import { GreenButton } from 'shared/components'
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle } from 'shared/components/ui/dialog'
import { useBoolean } from 'shared/hooks/use-boolean'

import { useGameContext } from '../game-context'
import { RatingChange } from './rating-change'

export const EndingDialog: FC = () => {
  const navigate = useNavigate()
  const { playTimeSound } = useSoundContext()
  const {
    game: { result, ratings, status },
    relativeGameData: { playerColor },
  } = useGameContext()
  const [review, toggleReview] = useBoolean()

  const isOpen = status === 'finished' && !review

  const myRatingChange = ratings.after && ratings.after[playerColor.bottom] - ratings.before[playerColor.bottom]
  const PlayerOrb = result && result.winner !== 'draw' && playerOrbs[result.winner].king

  useEffect(() => {
    if (isOpen && result && result.reason === 'timeout') {
      playTimeSound()
    }
  }, [playTimeSound, isOpen, result])

  return (
    <Dialog open={isOpen}>
      <DialogContent className="w-11/12 max-w-[850px] rounded-xl p-5">
        <DialogHeader>
          <DialogTitle>
            <div className="flex items-center gap-2">
              {PlayerOrb && <PlayerOrb className="h-[40px]" />}
              {result?.winner === 'draw' ? "It's a draw!" : `${startCase(result?.winner)} has won!`}
            </div>
          </DialogTitle>
        </DialogHeader>
        {(myRatingChange || myRatingChange === 0) && !isNaN(myRatingChange) && (
          <RatingChange change={myRatingChange}>
            <StarIcon />
          </RatingChange>
        )}
        <DialogClose asChild>
          <div className="flex gap-5">
            <GreenButton className="w-full" text="Home" onClick={() => navigate('/')} />
            <GreenButton className="w-full" text="Review" onClick={toggleReview} />
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
